import { CalculationRequestForm } from '@/components/features/CalculationRequests/forms/CalculationRequestForm';
import type { CalculationRequest, CalculationRequestOptions } from '@/components/features/CalculationRequests/types';
import { useTranslations } from '@/hooks/useTranslations';
import CreateLayout from '@/layouts/create-layout';
import { type BreadcrumbItem } from '@/types';
import { Head, router, usePage } from '@inertiajs/react';

interface CreatePageProps {
    options: CalculationRequestOptions;
    duplicateOf?: CalculationRequest | null;
    /** Set when the form was opened from a lead page — the lead is then fixed. */
    presetLeadId?: string | null;
    [key: string]: unknown;
}

export default function CalculationRequestCreate() {
    const { props } = usePage<CreatePageProps>();
    const { options, duplicateOf, presetLeadId = null } = props;
    const { t } = useTranslations();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: t('calculation_requests.create.breadcrumbs.calculation_requests', 'Calculation Requests'),
            href: '/calculation-requests',
        },
        {
            title: t('calculation_requests.create.breadcrumbs.create', 'Create'),
            href: '/calculation-requests/create',
        },
    ];

    return (
        <CreateLayout
            breadcrumbs={breadcrumbs}
            title={t('calculation_requests.create.heading', 'New calculation request')}
            subtitle={t('calculation_requests.create.subheading', 'Ask engineering to price a project')}
        >
            <Head title={t('calculation_requests.create.title', 'New calculation request')} />
            <CalculationRequestForm
                options={options}
                duplicateOf={duplicateOf}
                presetLeadId={presetLeadId}
                // Started from a lead, cancelling belongs back on that lead.
                onCancel={() => router.visit(presetLeadId ? `/leads/${presetLeadId}` : '/calculation-requests')}
            />
        </CreateLayout>
    );
}
